import {
  Stack,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Tabs,
  Tab,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import "../../../PrimeiraConsulta/modulos/styles.css";

import { ReactComponent as IconDocument } from "../../../../images/iconFile.svg";
import PrimeiraEtapa from "./ContentTab/PrimeiraEtapa";
import SegundaEtapa from "./ContentTab/SegundaEtapa";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-AnamneseNeurologica-${index}`}
      aria-labelledby={`simple-tab-AnamneseNeurologica-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "16px 0px" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-AnamneseNeurologica-${index}`,
    "aria-controls": `simple-tabpanel-AnamneseNeurologica-${index}`,
  };
}

export default function AnamneseNeurologica({
  tabValue,
  tabOnChange,
  data,
  small,
}) {
  return (
    <Accordion defaultExpanded={false} className="AccordionContainer">
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="anamneseNeurologica-content"
        id="anamneseNeurologica-header"
        className={`AccordionSummaryContainer ${small ? "small" : ""}`}
      >
        <Stack direction="row" alignItems="center" gap="8px " height="30px">
          <IconDocument style={{ width: "24px" }} />
          <Typography className={`Accordion_title ${small ? "small" : ""}`}>
            Anamnese neurológica
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            TabIndicatorProps={{
              style: {
                background: "#1E729F",
              },
            }}
            value={tabValue}
            onChange={tabOnChange}
            aria-label="center"
            sx={{
              fontFamily: "Nunito",
              fontWeight: 400,
              ".Mui-selected": {
                color: "#1E729F",
                fontWeight: "700 !important",
              },
            }}
          >
            <Tab
              label="Primeira etapa"
              {...a11yProps(0)}
              className="tabTitle"
            />
            <Tab label="Segunda etapa" {...a11yProps(1)} className="tabTitle" />
          </Tabs>
        </Box>
        <CustomTabPanel value={tabValue} index={0}>
          <PrimeiraEtapa data={data} />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <SegundaEtapa data={data} />
        </CustomTabPanel>
      </AccordionDetails>
    </Accordion>
  );
}
